import React from 'react';

const ProgressBar = ({ currentStep, totalSteps, className = "" }) => {
  const progress = (currentStep / totalSteps) * 100;

  return (
    <div className={`progress-bar-container ${className}`}>
      <div 
        className="progress-bar"
        style={{ width: `${progress}%` }}
      />
    </div>
  );
};

export default ProgressBar;

